import React, { useState } from 'react';
import { urlService } from 'core-utilities';
import { entityUrl } from 'core-roblox-utilities';
import { Link } from 'react-style-guide';
import PropTypes from 'prop-types';
import {
  Thumbnail2d,
  ThumbnailTypes,
  DefaultThumbnailSize,
  ThumbnailGameThumbnailSize,
  ThumbnailFormat
} from 'roblox-thumbnails';
import gameService from '../../gameData/services/gamesService';
import GameName from './GameName';
import CardInfo from './CardInfo';

function FeatureGameTile({ game, pageType, index }) {
  const { placeId, universeId } = game;
  const gameReferralUrl = urlService.getUrlWithQueries(entityUrl.game.getReferralPath(), {
    PageType: pageType,
    LocalTimestamp: new Date().toISOString(),
    PlaceId: placeId,
    Position: index + 1,
    IsLargeGameTile: true
  });
  const [thumbnailId, setThumbnailId] = useState(null);

  const gameIcon = (
    <Thumbnail2d
      type={ThumbnailTypes.gameIcon}
      size={DefaultThumbnailSize}
      targetId={universeId}
      imgClassName='brief-game-icon'
      format={ThumbnailFormat.jpeg}
    />
  );

  gameService.getFirstMediaId(universeId).then(thumbnailData => {
    if (thumbnailData?.imageId) {
      setThumbnailId(thumbnailData.imageId);
    }
  });

  return (
    <div className='featured-game-container game-card-container'>
      <Link url={gameReferralUrl} className='game-card-link'>
        <div className='thumb-container'>
          {thumbnailId && universeId && (
            <Thumbnail2d
              type={ThumbnailTypes.gameThumbnail}
              size={ThumbnailGameThumbnailSize.width576}
              baseTargetId={universeId}
              targetId={thumbnailId}
              imgClassName='thumb'
              format={ThumbnailFormat.jpeg}
            />
          )}
          <div className='thumb-mask' />
        </div>
        <div className='info-container'>
          <GameName game={game} />
          <CardInfo game={game} />
        </div>

        <div className='featured-game-icon-container'>{gameIcon}</div>
      </Link>
    </div>
  );
}

FeatureGameTile.propTypes = {
  game: PropTypes.shape({
    name: PropTypes.string,
    placeId: PropTypes.number,
    universeId: PropTypes.number,
    playerCount: PropTypes.number
  }).isRequired,
  pageType: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired
};

export default FeatureGameTile;
